<div class="container-fluid">
    <div class="row ms-sm-2 justify-content-center">
        <div class="col-10 outter-row">
            <p class="text-wrap heading">Employee Kpi Details</p>
        </div>
        <div class="form-group" data-select2-id="43">
            <label>Year and Month</label>
            <input class="form-control" style="width: 30%;" type="month" name="current" [(ngModel)]="year_month"
                (ngModelChange)="responseChange()" data-select2-id="1" tabindex="-1" aria-hidden="true">
        </div>
        <div class="col-2 outter-row">
            <!-- <button class="edit-button"  >Edit</button> -->
        </div>
        <div class="col-12 input-container">
            <div class="container-fluid">
                <section class="main-page-box">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 d-flex main-component-heading">
                                    <p class="main-page-sub-heading">
                                        {{OutputData.employee_name}}
                                    </p>
                                    <div class="line-div"></div>
                                </div>
                                <div class="col-12">
                                    <!-- for image -->
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="row content-box">
                                        <div class="col-6 col-md-4">
                                            <p>Month :</p>
                                        </div>
                                        <div class="col-6 col-md-8">
                                            <p>{{OutputData.month_year}}</p>
                                        </div>
                                        <div class="col-6 col-md-4">
                                            <p>Total Kpi :</p>
                                        </div>
                                        <div class="col-6 col-md-8">
                                            <p>{{OutputData.kpi_difference}}</p>
                                        </div>
                                        <div class="col-6 col-md-4">
                                            <p>Count :</p>
                                        </div>
                                        <div class="col-6 col-md-8">


                                            <div class="row content-box border m-2"
                                                *ngFor="let items of OutputData.count_list">
                                                <div class="col-6 col-md-4">
                                                    <p>Date : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{formatDate(items.date)}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Submitted Visit Plan : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.visitPlanWaitingpoint}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Visited: </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.visitplanApprovedPoint}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>RFR Over Due : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.rfr_over_due_count}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>RFR Missed : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.rfr_missed_kpi_point}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>RFR Over Due Items : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p *ngFor="let data of items.rfr_over_due">{{data}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>RFR Missed Items : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p *ngFor="let data of items.rfr_missed"> {{data}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Attendance : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.employee_attendance_point}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Total : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.total}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Unposted Invoices count : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.Unposted_invoices}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Pending Invoices count : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.hardcopy_not_received_invoices}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Unposted Invoices : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p *ngFor="let data of items.Unposted_list">{{data}}</p>
                                                </div>
                                                <div class="col-6 col-md-4">
                                                    <p>Pending Invoices : </p>
                                                </div>

                                                <div class="col-6 col-md-8">
                                                    <p *ngFor="let data of items.hard_copy_not_received_list">{{data}}
                                                    </p>
                                                </div>
                                                <!-- RFT Over Due -->
                                                <div class="col-6 col-md-4">
                                                    <p>RFT Over Due : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.rft_over_due_count}}</p>
                                                </div>

                                                <!-- RFT Over Due Items (if available) -->
                                                <div class="col-6 col-md-4"
                                                    *ngIf="items.rft_over_due && items.rft_over_due.length > 0">
                                                    <p>RFT Over Due Items : </p>
                                                </div>
                                                <div class="col-6 col-md-8"
                                                    *ngIf="items.rft_over_due && items.rft_over_due.length > 0">
                                                    <p *ngFor="let data of items.rft_over_due">{{data}}</p>
                                                </div>

                                                <!-- RFT Missed -->
                                                <div class="col-6 col-md-4">
                                                    <p>RFT Missed : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.rft_missed_kpi_point}}</p>
                                                </div>

                                                <!-- RFT Missed Items (if available) -->
                                                <div class="col-6 col-md-4"
                                                    *ngIf="items.rft_missed && items.rft_missed.length > 0">
                                                    <p>RFT Missed Items : </p>
                                                </div>
                                                <div class="col-6 col-md-8"
                                                    *ngIf="items.rft_missed && items.rft_missed.length > 0">
                                                    <p *ngFor="let data of items.rft_missed">{{data}}</p>
                                                </div>

                                                <!-- Projection KPI -->
                                                <div class="col-6 col-md-4">
                                                    <p>Projection KPI : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.projection_kpi_point}}</p>
                                                </div>

                                                <!-- Invoice Transfer Trip KPI -->
                                                <div class="col-6 col-md-4">
                                                    <p>Invoice Transfer Trip KPI : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.inv_transfer_trip_kpi_point}}</p>
                                                </div>

                                                <!-- Sale Order KPI -->
                                                <div class="col-6 col-md-4">
                                                    <p>Sale Order KPI : </p>
                                                </div>
                                                <div class="col-6 col-md-8">
                                                    <p>{{items.sale_order_kpi_point}}</p>
                                                </div>
                                            </div>






                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

    </div>
</div>